import { createSvgIcon } from '@mui/material/utils';

export const RadioCheckedIcon = createSvgIcon(
    <svg viewBox="0 0 20 20">
        <circle cx="10" cy="10" r="9" fill="none" strokeWidth="2" />
        <circle cx="10" cy="10" r="6" stroke="none" />
    </svg>,
    "RadioChecked"
);

export default RadioCheckedIcon;
